import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", testId = "site-logo", to = "/" }) => {
  const sizes = {
    sm: "w-32 h-10",
    md: "w-40 h-12",
    lg: "w-48 h-14",
  };
  return (
    <Link to={to} data-testid={testId} className={`inline-flex shrink-0 overflow-hidden rounded-lg bg-white align-middle select-none ${sizes[size] || sizes.md}`}>
      <img
        src={`${process.env.PUBLIC_URL || ""}/img/repairo_logo.jpeg`}
        alt="Repairro"
        width={1254}
        height={1254}
        className="h-full w-full object-cover object-center"
      />
    </Link>
  );
};

export default Logo;
